module.exports = __webpack_public_path__ + "img/9.982999f9.png";